"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const header_1 = require("../header");
const navigation_1 = require("../navigation");
const styles_1 = require("./styles");
exports.Layout = (0, react_1.forwardRef)((props, ref) => {
    const { headerProps, sidebarProps, hasFilter, children } = props;
    const [isMenuExpanded, handleExpanded] = (0, react_1.useState)(false);
    const hasSidebar = sidebarProps && sidebarProps.items.length > 1;
    const hasTabs = Boolean(headerProps === null || headerProps === void 0 ? void 0 : headerProps.tabsProps);
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledLayout, { fullScreen: true, ...{ isMenuExpanded, hasSidebar, hasFilter, hasTabs }, hasHeader: Boolean(headerProps), "aria-label": "layout-wrapper", ref: ref, children: [hasSidebar ? ((0, jsx_runtime_1.jsx)(navigation_1.Navigation, { ...sidebarProps, handleExpanded: handleExpanded, isExpanded: isMenuExpanded })) : null, headerProps && (0, jsx_runtime_1.jsx)(header_1.Header, { ...headerProps }), children] }));
});
exports.Layout.displayName = 'Layout';
exports.default = exports.Layout;
//# sourceMappingURL=layout.js.map